<template>
  <el-dialog
      v-model="isShow"
      :title="$t('common.detail.history.ai')"
      :footer="null"
      centered
      top="8em"
      :width="400"
      style="min-width:300px;"
      destroyOnClose
      :modal="true"
      @cancel="close"
      custom-class="dialog-class-detail"
      :close-on-click-modal="false"
  >
    <template #default style="padding: 0px !important;">
      <div class="detail-content">
        <div>
          <div class="item">
            <div class="top">
              <div>{{$t('side.bar.my')}}</div>
              <div>{{ currentTargetChat[defaultCurrent].createTime }}</div>
            </div>
            <div class="content">
              {{ currentTargetChat[defaultCurrent].question }}
            </div>
          </div>
          <div class="item">
            <div class="top">
              <div>{{$t('ai.title')}}</div>
              <div>{{ currentTargetChat[defaultCurrent].createTime }}</div>
            </div>
            <div class="content">
              {{ currentTargetChat[defaultCurrent].content }}
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: flex-end;margin-top: 20px">
        <PageCom :isChatDetail="true" :item="currentTargetChat" @changeCurrent="changeCurrent"></PageCom>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits, reactive, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import {i18n} from "@/lang";
import PageCom from "@/components/AI/Page.vue";

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const teamName = ref("")
const loading = ref(false);

const {value, isChecked} = defineProps({
  value: {type: Boolean, default: false},
  isChecked: {type: Array, default: []}
})
const currentTargetChat = computed(() => store.state.AI.currentTargetChat)

// 选中的项 最上面的项
const defaultCurrent = ref(currentTargetChat.value.length - 1)

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})

const close = () => {
  emit("close");
}
const changeCurrent = (val) => {
  console.log(val, 'page')
  defaultCurrent.value = (val - 1)
}

</script>
<style scoped lang="less">
.detail-content {
  overflow: scroll;
  max-height: 450px;
  padding-right: 20px;

  .item {
    border-bottom: 1px solid #efefef;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      margin-top: 8px;
    }

    .top > div {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }

    .content {
      margin-bottom: 10px;
    }
  }
}

.dialog-class-detail {
  padding: 10px !important;
}
</style>